<script>
/**
     * @overview 素材弹窗
     *
     * @author jiangzhijie
     */

import mapUtils, { $http } from "@/utils";
import FileList from "./FileList.vue";

export default {
  name: "MaterialReview",

  components: {
    FileList,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
    },
    // 是否多选
    isMul: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    searchText: '', // 搜索内容
    loading: {
      init: false,
      fetch: false,
      submit: false,
    },

    list: {
      data: [],
    },
    item: null, // 选中素材项

    review: "",

    query: {
      page: 1,

      per_page: 27,

      "like[name]": "",

      "equal[type]": null,
    },
  }),

  computed: {
    types() {
      const type = JSON.parse(JSON.stringify(this.$store.state.material.types));
      const data = [];
      switch (this.id) {
        case "image":
          Object.keys(type).forEach((key) => {
            if (type[key].parent_value === 1 && (type[key].parent_value !== type[key].value)) {
              data.push(type[key]);
            }
          });
          break;
        case "audio":
          Object.keys(type).forEach((key) => {
            if (type[key].parent_value === 2) {
              data.push(type[key]);
            }
          });
          break;
        case "video":
          Object.keys(type).forEach((key) => {
            if (type[key].parent_value === 3) {
              data.push(type[key]);
            }
          });
          break;
        case "animation":
          Object.keys(type).forEach((key) => {
            if (type[key].parent_value === 21) {
              data.push(type[key]);
            }
          });
          break;
        case "pdf":
          Object.keys(type).forEach((key) => {
            if (type[key].parent_value === 4) {
              data.push(type[key]);
            }
          });
          break;
        case "doc":
          Object.keys(type).forEach((key) => {
            if (type[key].parent_value === 5) {
              data.push(type[key]);
            }
          });
          break;
      }
      return data;
    },
  },

  created() {
    if (this.types && this.types[0] && this.types[0].value) this.query["equal[type]"] = this.types[0].value;
    this.gameFetchList();
  },

  methods: {
    ...mapUtils("list", ["fetch", "routeQuery"]),

    ...mapUtils("form", ["submit", "errorAlert"]),


    reviewCheckin(file) {
      this.review = file.url;
    },

    gameFetchList() {
      this.query['like[name]'] = this.searchText;
      this.loading.fetch = true;

      const query = this.$list_routeQuery(this.query, {});

      return this.$list_fetch("/resource", query)
        .then((res) => {
          this.list = res;
        })
        .finally(() => {
          this.loading.fetch = false;
        });
    },

    queryPage(value) {
      this.query.page = value;

      this.gameFetchList();
    },

    queryType(value) {
      this.query["equal[type]"] = value;
      // this.query["like[name]"] = "";
      this.gameFetchList();
    },

    queryName(nameQuery) {
      this.query['like[name]'] = this.searchText;
      this.query = { ...this.query, ...nameQuery, page: 1 };

      this.gameFetchList();
    },
    checked(url, item) {
      this.review = url;
      this.item = item;
    },
    changeFile(url, item) {
      this.review = url;
      this.$emit("success", this.review, this.id, item);
    },
    submit() {
      const file = this.review;
      if (file.length <= 0) {
        this.$alert("请选择文件！");
      } else {
        this.$emit("success", file, this.id, this.item);
        this.clearAll();
      }
    },

    cancel() {
      this.$emit("cancel");
      this.clearAll();
    },
    clearAll() {
      this.review = '';
      this.$refs.FileList.clearAll();
    },
  },
};
</script>

<template>
  <div
    v-loading="loading.fetch || loading.init"
    class="course-detail-review"
  >
    <div class="search-box-review">
      <AppQueryName
        :value.sync="searchText"
        @query="queryName"
      />
    </div>
    <div class="course-detail-review__header">
      <v-radio-text
        :value="query['equal[type]']"
        :list="types"
        label-key="name"
        @change="queryType"
      />
    </div>

    <div class="course-detail-review__body">
      <FileList
        ref="FileList"
        :id="id"
        :data="list"
        :is-mul="isMul"
        @checked="checked"
        @changeFile="changeFile"/>
    </div>

    <AppPagination
      :list="list"
      :size="query.per_page"
      @changeIndex="queryPage"
    />

    <AppFormSubmit
      :submitting="loading.submit"
      @submit="submit"
      @cancel="cancel"
    />
  </div>
</template>

<style lang="postcss">
    .course-detail-review {
        flex-direction: column;
        display: flex;
        /*height: 700px;*/
        height: auto;
    }

    .search-box-review{
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }

    .course-detail-review__header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--bd-color-default);
        padding-bottom: 1.5em;
        margin-bottom: 1.5em;
    }

    .course-detail-review__header .el-input-group {
        width: auto;
    }

    .course-detail-review__body {
        display: flex;
        flex: auto;
    }

    .course-detail-review__value {
        flex: none;
        display: flex;
        flex-direction: column;
        width: 260px;
        padding-right: 1em;
        margin-right: 1em;
        border-right: 1px solid var(--bd-color-default);
    }

    .course-detail-review__value > :not(:last-child) {
        margin-bottom: 6px;
    }

    .course-detail-review__value .el-tag {
        display: flex;
        align-items: center;
    }

    .course-detail-review__value .el-tag__close {
        margin-left: auto;
        margin-bottom: -2px;
        padding-top: 1px;
    }

    .course-detail-review__table {
        flex: auto;
    }

    /* 取出el-table append时的下边 */
    .course-detail-review__table.el-table::before {
        background-color: transparent;
    }
</style>
